
import React from "react";
import "./Promotions.css";
import CardPromotion from "./CardPromotion";
import { usePromotionsBannerQuery } from "hooks/usePromotions";
import { API } from "utils/Helper";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const BannerSkeleton = styled.div`
  width: 100%;
  aspect-ratio: 5 / 1;
  background: linear-gradient(90deg, #213743 25%, #2f4553 50%, #213743 75%);
  background-size: 600px 100%;
  border-radius: 15px;
  margin-bottom: 25px;
  animation: ${shimmer} 1.4s infinite linear;
`;

function Promotions() {
  const { data: banners = [], isLoading: bannerLoading } = usePromotionsBannerQuery("promotions");
  const banner = banners.length > 0 ? banners[0] : null;

  let imgSrc = null;
  if (banner && banner.image_url) {
    imgSrc = banner.image_url.startsWith("http") || banner.image_url.startsWith("/uploads")
      ? (banner.image_url.startsWith("http") ? banner.image_url : `${API}${banner.image_url}`)
      : banner.image_url;
  }

  return (
    <div style={{ width: "100%" }}>
      <h4 style={{ fontWeight: "bold", paddingBottom: "15px", color: "#fff", fontSize: "1.5rem" }}> Promotion </h4>

      {/* Full-width Promo Banner */}
      {bannerLoading ? (
        <BannerSkeleton />
      ) : imgSrc ? (
        <div style={{ width: "100%", marginBottom: "25px" }}>
          {banner && banner.link_url ? (
            <a href={banner.link_url} style={{ display: "block", width: "100%" }}>
              <img
                src={imgSrc}
                alt="Promotions Banner"
                style={{
                  width: "100%",
                  aspectRatio: "5 / 1",
                  objectFit: "cover",
                  borderRadius: "15px",
                  display: "block"
                }}
              />
            </a>
          ) : (
            <img
              src={imgSrc}
              alt="Promotions Banner"
              style={{
                width: "100%",
                aspectRatio: "5 / 1",
                objectFit: "cover",
                borderRadius: "15px",
                display: "block"
              }}
            />
          )}
        </div>
      ) : null}

      <CardPromotion />
    </div>
  );
}

export default Promotions;

